import { render, staticRenderFns } from "./PixelBase.vue?vue&type=template&id=34a79747&scoped=true&"
import script from "./PixelBase.vue?vue&type=script&lang=js&"
export * from "./PixelBase.vue?vue&type=script&lang=js&"
import style0 from "./PixelBase.vue?vue&type=style&index=0&id=34a79747&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a79747",
  null
  
)

export default component.exports